import { render, staticRenderFns } from "./NonIndividualEscalations.vue?vue&type=template&id=261df0b2&scoped=true&"
import script from "./NonIndividualEscalations.vue?vue&type=script&lang=js&"
export * from "./NonIndividualEscalations.vue?vue&type=script&lang=js&"
import style0 from "./NonIndividualEscalations.vue?vue&type=style&index=0&id=261df0b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261df0b2",
  null
  
)

export default component.exports